(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ninja-stress-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(scope) {
    scope.querySelectorAll('[data-sr-video] video').forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready='true';
      if(matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData)return;
      if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)video.play().catch(()=>{});else video.pause();}));observer.observe(video);}
    });
  }
  setup(document);document.addEventListener('shopify:section:load',e=>setup(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ninja-stress-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    const text=JSON.parse(root.querySelector('[data-sr-config]').textContent);
    const cards=Array.from(root.querySelectorAll('[data-sr-card]'));
    const grid=root.querySelector('.sr-grid'), more=root.querySelector('[data-sr-more]'), adjustable=root.querySelector('[data-sr-adjustable]'), sort=root.querySelector('[data-sr-sort]');
    const sizeFilter=root.querySelector('[data-sr-size]'),colorFilter=root.querySelector('[data-sr-color]');
    const canonicalColor=v=>({silver:'silver',hopea:'silver',silber:'silver',gold:'gold',kulta:'gold',guld:'gold',black:'black',musta:'black',svart:'black',schwarz:'black',grey:'grey',gray:'grey',harmaa:'grey',grå:'grey',grau:'grey','rose gold':'rose_gold',rosegold:'rose_gold',ruusukulta:'rose_gold',roséguld:'rose_gold',roségold:'rose_gold',geometric:'patterned'})[v.toLowerCase()]||v;
    const datasets=new Map(cards.map(c=>[c,JSON.parse(c.querySelector('[data-sr-product]').textContent)]));
    const sizeSet=new Set(),colorSet=new Set();
    cards.forEach(c=>{const p=datasets.get(c);const idx=p.options.findIndex(o=>/koko|size|storlek|größe/i.test(o));c.sizes=idx<0?[]:p.variants.filter(v=>v.available).map(v=>v.options[idx]);c.colors=(c.dataset.colors||'').split('|').filter(Boolean).map(canonicalColor);c.sizes.forEach(v=>sizeSet.add(v));c.colors.forEach(v=>colorSet.add(v));});
    [...sizeSet].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true})).forEach(v=>sizeFilter.add(new Option(v,v)));
    [...colorSet].sort().forEach(v=>colorFilter.add(new Option(text.colors[v]||v,v)));root.querySelector('[data-sr-color-wrap]').hidden=colorSet.size<2;
    const money=new Intl.NumberFormat(text.locale,{style:'currency',currency:text.currency});
    let group='all',limit=8,lastTrigger=null;
    function render(){
      const matching=cards.filter(c=>(group==='all'||(group==='sets'?c.dataset.bundle==='true':c.dataset.group===group))&&(!adjustable.checked||c.dataset.adjustable==='true')&&(!sizeFilter.value||c.sizes.includes(sizeFilter.value))&&(!colorFilter.value||c.colors.includes(colorFilter.value)));
      matching.sort((a,b)=>sort.value==='asc'?Number(a.dataset.price)-Number(b.dataset.price):sort.value==='desc'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.index)-Number(b.dataset.index));
      cards.forEach(c=>c.hidden=true);matching.forEach((c,i)=>{grid.append(c);c.hidden=i>=limit;});
      root.querySelector('[data-sr-count]').textContent=text.count.replace('__count__',matching.length);
      root.querySelector('[data-sr-progress]').textContent=text.progress.replace('__shown__',Math.min(limit,matching.length)).replace('__total__',matching.length);
      more.hidden=matching.length<=limit;root.querySelector('.sr-empty').hidden=matching.length>0;
      root.querySelectorAll('[data-sr-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.srFilter===group)));
    }
    const track=(name,detail={})=>document.dispatchEvent(new CustomEvent('ninja:stress-landing',{detail:{action:name,...detail}}));
    root.querySelectorAll('[data-sr-filter]').forEach(b=>b.addEventListener('click',()=>{group=b.dataset.srFilter;limit=8;render();track('filter',{group});}));
    [adjustable,sort,sizeFilter,colorFilter].forEach(c=>c.addEventListener('change',()=>{limit=8;render();}));
    more.addEventListener('click',()=>{limit+=8;render();});
    root.querySelector('[data-sr-reset]').addEventListener('click',()=>{group='all';adjustable.checked=false;sort.value='manual';sizeFilter.value='';colorFilter.value='';limit=8;render();});
    root.querySelectorAll('[data-sr-jump]').forEach(b=>b.addEventListener('click',()=>{group=b.dataset.srJump;limit=8;render();root.querySelector('#sr-shop').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));
    function show(dialog,trigger){lastTrigger=trigger;dialog.showModal();document.documentElement.classList.add('sr-modal-open');trigger?.classList.add('is-open');track('quick_open',{handle:dialog.dataset.handle});}
    cards.forEach(card=>{
      const product=JSON.parse(card.querySelector('[data-sr-product]').textContent);
      const dialog=card.querySelector('dialog'),form=card.querySelector('form'),add=card.querySelector('.sr-add'),id=form.querySelector('[name=id]'),status=dialog.querySelector('[data-sr-status]');
      card.srDialog=dialog;dialog.dataset.handle=card.dataset.handle;
      const radios=Array.from(form.querySelectorAll('[data-sr-option]'));
      function selected(){const options=Array(product.options.length).fill(null);radios.forEach(i=>{if(i.type==='hidden'||i.checked)options[Number(i.dataset.srOption)]=i.value;});return options;}
      function sync(){
        const options=selected();
        const variant=product.variants.find(v=>v.options.every((o,i)=>o===options[i])) || (!radios.length?product.variants.find(v=>v.available):null);
        id.value=variant?.available?variant.id:'';
        radios.filter(i=>i.type==='radio').forEach(i=>{i.disabled=!product.variants.some(v=>v.available&&v.options[Number(i.dataset.srOption)]===i.value&&options.every((o,j)=>!o||j===Number(i.dataset.srOption)||v.options[j]===o));});
        add.disabled=!variant?.available;add.textContent=variant&&!variant.available?text.sold:text.add;
        if(variant)dialog.querySelector('[data-sr-price]').textContent=money.format(variant.price/100);
      }
      form.addEventListener('change',()=>{status.textContent='';sync();});sync();
      const opener=card.querySelector('[data-sr-open]');
      opener.addEventListener('click',()=>{
        if(card.dataset.bundle==='true'&&!radios.some(i=>i.type==='radio')){form.requestSubmit(add);return;}
        show(dialog,opener);
      });
      dialog.querySelector('[data-sr-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',e=>{if(e.target!==dialog)return;const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();});
      dialog.addEventListener('close',()=>{document.documentElement.classList.remove('sr-modal-open');opener.classList.remove('is-open');lastTrigger?.focus({preventScroll:true});});
      dialog.querySelectorAll('[data-sr-qty]').forEach(b=>b.addEventListener('click',()=>{const q=dialog.querySelector('[name=quantity][type=number]');q.value=Math.max(1,(Number(q.value)||1)+Number(b.dataset.srQty));}));
      dialog.querySelectorAll('[data-sr-sibling]').forEach(link=>link.addEventListener('click',e=>{const sibling=cards.find(c=>c.dataset.handle===link.dataset.srSibling);if(!sibling)return;e.preventDefault();dialog.close();show(sibling.srDialog,opener);}));
      form.addEventListener('submit',async e=>{
        e.preventDefault();e.stopImmediatePropagation();
        if(form.dataset.busy||!id.value||!form.reportValidity())return;
        const quantity=Number(new FormData(form).get('quantity')||1);if(!Number.isInteger(quantity)||quantity<1)return;
        form.dataset.busy='true';add.disabled=true;opener.disabled=true;add.textContent=text.busy;opener.dataset.oldText=opener.textContent;opener.textContent=text.busy;status.textContent='';
        try{
          const res=await fetch(text.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(id.value),quantity}]})});
          const data=await res.json();if(!res.ok)throw new Error(data.description||text.error);
          status.textContent=text.added;dialog.querySelector('.sr-cart-link').hidden=false;track('add',{variantId:id.value,quantity});
          document.dispatchEvent(new CustomEvent('cart:build'));
          if(!dialog.open)show(dialog,opener);
        }catch(error){status.textContent=error.message||text.error;if(!dialog.open)show(dialog,opener);}
        finally{delete form.dataset.busy;opener.disabled=false;opener.textContent=opener.dataset.oldText;sync();}
      });
    });
    cards.forEach(card=>root.append(card.srDialog));
    root.classList.add('is-ready');render();
  }
  document.querySelectorAll('[data-stress-landing]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-stress-landing]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ninja-titanium-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const text = JSON.parse(root.querySelector('[data-ti-config]').textContent);
    const cards = Array.from(root.querySelectorAll('[data-ti-card]'));
    const grid = root.querySelector('.ti-grid');
    const flat = root.querySelector('[data-ti-flat]');
    const sort = root.querySelector('[data-ti-sort]');
    const more = root.querySelector('[data-ti-more]');
    let selected = 'all', limit = 8;
    function render() {
      const matching = cards.filter(c => (selected === 'all' || c.dataset.type === selected) && (!flat.checked || c.dataset.flat === 'true'));
      matching.sort((a,b) => sort.value === 'asc' ? Number(a.dataset.price)-Number(b.dataset.price) : sort.value === 'desc' ? Number(b.dataset.price)-Number(a.dataset.price) : Number(a.dataset.index)-Number(b.dataset.index));
      cards.forEach(c => c.hidden = true);
      matching.forEach((c,i) => { grid.append(c); c.hidden = i >= limit; });
      root.querySelector('[data-ti-count]').textContent = matching.length + ' ' + text.count;
      root.querySelector('.ti-empty').hidden = matching.length > 0;
      const progress=root.querySelector('[data-ti-progress]');
      progress.textContent=text.progress.replace('__shown__',String(Math.min(limit,matching.length))).replace('__total__',String(matching.length));
      progress.hidden=matching.length===0;
      more.hidden = matching.length <= limit;
      root.querySelectorAll('[data-ti-filter]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.tiFilter === selected)));
    }
    root.classList.add('ti-ready'); render();
    root.querySelectorAll('[data-ti-filter]').forEach(b => b.addEventListener('click',() => { selected=b.dataset.tiFilter;limit=8;render(); }));
    [flat,sort].forEach(e=>e.addEventListener('change',()=>{limit=8;render();}));
    more.addEventListener('click',()=>{const old=limit;limit+=8;render();const visible=Array.from(grid.children).filter(c=>!c.hidden);visible[old]?.querySelector('a')?.focus({preventScroll:true});});
    root.querySelector('[data-ti-reset]').addEventListener('click',()=>{selected='all';flat.checked=false;sort.value='popular';limit=8;render();});
    root.querySelectorAll('[data-ti-jump]').forEach(a=>a.addEventListener('click',()=>{selected=a.dataset.tiJump==='flat'?'all':a.dataset.tiJump;flat.checked=a.dataset.tiJump==='flat';limit=8;render();}));
    root.querySelectorAll('.ti-form').forEach(form=>{
      const addButton=form.querySelector('[type=submit]');
      if(form.querySelector('input[type=radio]'))addButton.disabled=!form.querySelector('input[name=id]:checked');
      form.addEventListener('change',e=>{
        if(e.target.name!=='id')return;
        const card=form.closest('.ti-card');
        addButton.disabled=false;
        const choiceLabel=card.querySelector('.ti-choice-label');
        if(choiceLabel)choiceLabel.textContent=e.target.dataset.label;
        card.querySelector('[data-ti-price]').textContent=e.target.dataset.price;
        if(e.target.dataset.image){const img=card.querySelector('.ti-card-image img');img.removeAttribute('srcset');img.src=e.target.dataset.image;}
        form.querySelector('.ti-form-status').textContent='';
      });
      form.addEventListener('submit',async e=>{
        e.preventDefault();e.stopImmediatePropagation();
        if(form.dataset.sending||!form.reportValidity())return;
        const button=form.querySelector('[type=submit]');
        const status=form.querySelector('.ti-form-status');
        const input=form.querySelector('input[name=id]:checked, input[name=id][type=hidden]');
        if(!input)return;
        form.dataset.sending='true';button.disabled=true;button.textContent=text.busy;
        try{
          const res=await fetch(text.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(input.value),quantity:1}]})});
          const data=await res.json();if(!res.ok)throw new Error(data.description||text.error);
          status.textContent=text.added;form.querySelector('.ti-cart-link').hidden=false;
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('ninja:titanium-add',{detail:{variantId:input.value}}));
        }catch(error){status.textContent=error.message||text.error;form.querySelector('.ti-cart-link').hidden=false;}
        finally{delete form.dataset.sending;button.disabled=false;button.textContent=text.add;}
      });
    });
    if('IntersectionObserver' in window){
      let heroVisible=true,shopVisible=false;
      const sticky=root.querySelector('.ti-sticky');
      const observer=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.target.classList.contains('ti-hero'))heroVisible=e.isIntersecting;else shopVisible=e.isIntersecting;});sticky.hidden=heroVisible||shopVisible;},{threshold:0});
      observer.observe(root.querySelector('.ti-hero'));observer.observe(root.querySelector('.ti-shop'));
    }
  }
  document.querySelectorAll('[data-titanium-landing]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-titanium-landing]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
